export default __webpack_public_path__ + "static/media/resource-hub-hero2.695559af.svg";